import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement> & { size?: number };

const base = (size: number): React.SVGProps<SVGSVGElement> => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
});

export const MailIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3 7 9 6 9-6" />
  </svg>
);

export const LockIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <rect x="4" y="11" width="16" height="9" rx="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </svg>
);

export const EyeIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const EyeOffIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="M9.9 5.2A9.5 9.5 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-3 3.9" />
    <path d="M6.1 6.1A17 17 0 0 0 2 12s3.5 7 10 7a9.5 9.5 0 0 0 4.1-.9" />
    <path d="m3 3 18 18" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
  </svg>
);

export const SunIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
  </svg>
);

export const MoonIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" />
  </svg>
);

export const MonitorIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <rect x="3" y="4" width="18" height="12" rx="2" />
    <path d="M8 20h8M12 16v4" />
  </svg>
);

export const DashboardIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="M12 3a9 9 0 1 0 9 9h-9Z" />
    <path d="M13 3.05A9 9 0 0 1 20.95 11H13Z" />
  </svg>
);

export const SearchIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <circle cx="11" cy="11" r="7" />
    <path d="m21 21-4.3-4.3" />
  </svg>
);

export const FilePlusIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="M14 3v5h5" />
    <path d="M19 21V8l-5-5H6a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1Z" />
    <path d="M12 12v5M9.5 14.5h5" />
  </svg>
);

export const UsersIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3.5 20a5.5 5.5 0 0 1 11 0" />
    <path d="M16 6.2a3 3 0 0 1 0 5.6M17.5 20a5.5 5.5 0 0 0-2.5-4.6" />
  </svg>
);

export const ContactIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <circle cx="9" cy="11" r="2" />
    <path d="M6 16a3 3 0 0 1 6 0M15 9h3M15 13h3" />
  </svg>
);

export const TruckIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z" />
    <circle cx="7" cy="18" r="1.6" />
    <circle cx="17" cy="18" r="1.6" />
  </svg>
);

export const UserCircleIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="10" r="3" />
    <path d="M6.5 18.5a6 6 0 0 1 11 0" />
  </svg>
);

export const ChevronLeftIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="m15 6-6 6 6 6" />
  </svg>
);

export const RefreshIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="M21 12a9 9 0 1 1-2.64-6.36" />
    <path d="M21 4v4h-4" />
  </svg>
);

export const InboxIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="M4 13h4l1.5 3h5L16 13h4" />
    <path d="M5 5h14l1.5 8v5a1 1 0 0 1-1 1H4.5a1 1 0 0 1-1-1v-5Z" />
  </svg>
);

export const CalendarIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <rect x="3.5" y="5" width="17" height="16" rx="2" />
    <path d="M3.5 9h17M8 3v4M16 3v4" />
  </svg>
);

export const AlertTriangleIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="M12 4 2.8 20h18.4Z" />
    <path d="M12 10v4M12 17.5v.01" />
  </svg>
);

export const FilterIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="M3 5h18l-7 8v6l-4-2v-4Z" />
  </svg>
);

export const FileReportIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="M14 3v5h5" />
    <path d="M19 21V8l-5-5H6a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1Z" />
    <path d="M8 13h6M8 17h4" />
  </svg>
);

/**
 * Procesador — sección Desarrollador.
 *
 * El cuadro interior va **concéntrico** y no relleno: a 20 px un relleno se ve
 * como un botón y pierde la lectura de chip. Las ocho patas salen de los cuatro
 * lados, que es lo que lo hace reconocible de inmediato incluso pequeño.
 */
export const CpuIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <rect x="4" y="4" width="16" height="16" rx="2" />
    <rect x="9" y="9" width="6" height="6" rx="1" />
    <path d="M9 2v2M15 2v2M9 20v2M15 20v2M2 9h2M2 15h2M20 9h2M20 15h2" />
  </svg>
);

export const ChevronRightIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="m9 6 6 6-6 6" />
  </svg>
);

export const CatalogIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z" />
    <path d="M9 3v18" />
  </svg>
);

export const LogoutIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <path d="m16 17 5-5-5-5" />
    <path d="M21 12H9" />
  </svg>
);

export const ChevronDownIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg {...base(size)} {...rest}>
    <path d="m6 9 6 6 6-6" />
  </svg>
);

export const PlaneIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M17.8 19.2 16 11l3.5-3.5a2.12 2.12 0 0 0-3-3L13 8 4.8 6.2a.5.5 0 0 0-.5.8l3.2 3.6-2 2-2.3-.6a.5.5 0 0 0-.5.8L5 15.5l.7 2.3a.5.5 0 0 0 .8-.1l2-2 3.6 3.2a.5.5 0 0 0 .8-.5Z" />
  </svg>
);

export const ShipIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M2 20a2.4 2.4 0 0 0 2-1 2.4 2.4 0 0 1 4 0 2.4 2.4 0 0 0 4 0 2.4 2.4 0 0 1 4 0 2.4 2.4 0 0 0 4 0 2.4 2.4 0 0 1 2 1" />
    <path d="M4 15.5 3 12h18l-1.3 4.2" />
    <path d="M6 12V7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v5" />
    <path d="M12 6V3" />
  </svg>
);

/**
 * Buque de carga de **perfil, con la proa a la derecha**.
 *
 * Existe además de `ShipIcon` (que es de frente) porque se usa donde tiene que leerse como
 * *avanzando*: el marcador de posición en el mapa, el vehículo que recorre la barra de progreso
 * y el conector origen → destino. Un barco visto de frente no sugiere dirección.
 *
 * ⚠️ Va **relleno** y no con trazo como el resto del juego de iconos. Es deliberado: se dibuja
 * a 14–18 px dentro de un círculo de color, y ahí un trazo de 1.8 px se convierte en una
 * manchita ilegible. La silueta llena sí se reconoce.
 */
export const ShipSideIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" {...rest}>
    {/* Casco con proa apuntando a la derecha */}
    <path d="M2.6 13H17.8l4 1.6-4.4 3H5.4z" />
    {/* Puente, hacia la popa */}
    <path d="M4.6 13V9.6h3.6V13z" />
    {/* Chimenea */}
    <path d="M5.6 9.6V7.8h1.6v1.8z" />
    {/* Contenedores en cubierta */}
    <path d="M9.8 13v-2.2h4.6V13z" />
  </svg>
);

/**
 * Avión de **perfil, con la nariz a la derecha**. Mismo motivo y misma decisión de relleno que
 * `ShipSideIcon`: se usa donde el icono tiene que comunicar avance.
 */
export const PlaneSideIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" {...rest}>
    {/* Fuselaje, con la nariz redondeada a la derecha */}
    <path d="M5.3 11.6h12.4c2.7 0 4.4 1.1 4.4 2.1s-1.7 2.1-4.4 2.1H5.3z" />
    {/* Estabilizador vertical, inclinado hacia atrás */}
    <path d="M6.4 11.6 3.3 6.8h2l3.6 4.8z" />
    {/* Ala en flecha */}
    <path d="M10.2 15.8 4.9 20.4h2.4l6.6-4.6z" />
  </svg>
);

export const TrashIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14" />
  </svg>
);

export const CodeIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="m9 18-6-6 6-6M15 6l6 6-6 6" />
  </svg>
);

export const PackageIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M21 8v8a2 2 0 0 1-1 1.73l-7 4a2 2 0 0 1-2 0l-7-4A2 2 0 0 1 3 16V8a2 2 0 0 1 1-1.73l7-4a2 2 0 0 1 2 0l7 4A2 2 0 0 1 21 8Z" />
    <path d="m3.3 7 8.7 5 8.7-5M12 22V12" />
  </svg>
);

export const LayersIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="m12 2 9 5-9 5-9-5 9-5Z" />
    <path d="m3 12 9 5 9-5M3 17l9 5 9-5" />
  </svg>
);

export const ChartIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M3 3v18h18" />
    <path d="M7 15v-4M12 15V7M17 15v-6" />
  </svg>
);

/** Tractocamión con caja: identifica la modalidad terrestre. */
export const TrailerIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    {/* Caja del remolque */}
    <path d="M2 5h12v11H2z" />
    {/* Cabina */}
    <path d="M14 9h3.5l2.5 3v4H14z" />
    {/* Ruedas */}
    <circle cx="6.5" cy="18" r="1.8" />
    <circle cx="17" cy="18" r="1.8" />
    <path d="M8.3 18h6.9M2 16h2.7" />
  </svg>
);

/**
 * Bodega / instalación.
 * Se usa para Deliveries porque en este dominio un "delivery" es una UBICACIÓN
 * (shipper o consignee con dirección y contacto), no un vehículo.
 */
export const WarehouseIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    {/* Techo y muros */}
    <path d="M2 20V9.5a1 1 0 0 1 .6-.92l9-3.9a1 1 0 0 1 .8 0l9 3.9a1 1 0 0 1 .6.92V20" />
    <path d="M2 20h20" />
    {/* Portón de carga */}
    <path d="M7 20v-6h10v6" />
    <path d="M7 17h10" />
  </svg>
);

/** Alternativa para Deliveries: punto en el mapa. */
export const MapPinIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

/**
 * Radar: se usa en Track Shipment.
 * Antes compartía el icono de barco con Ocean, lo que confundía dos cosas
 * distintas (una modalidad vs la herramienta de rastreo).
 */
export const RadarIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    {/* Ondas concéntricas */}
    <path d="M12 12a4 4 0 0 1 4-4" />
    <path d="M12 12a8 8 0 0 1 8-8" />
    {/* Barrido y centro */}
    <path d="M12 12 4.5 19.5" />
    <circle cx="12" cy="12" r="1.6" />
    <path d="M20.5 14a9 9 0 1 1-10.5-9.9" />
  </svg>
);

/**
 * Hamburguesa del menú móvil.
 *
 * Reemplaza la que se dibujaba con bordes CSS (`border-top` + `::after`): esa quedaba con
 * esquinas cuadradas y grosor distinto al del resto de los iconos, que usan trazo redondeado
 * de 1.8. La tercera línea va **más corta** a propósito — es el detalle que hace que se lea
 * como icono y no como tres rayas iguales.
 */
export const MenuIcon: React.FC<IconProps> = ({ size = 20, ...rest }) => (
  <svg {...base(size)} {...rest} strokeWidth={2}>
    <path d="M4 7h16M4 12h16M4 17h10" />
  </svg>
);
